var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bilder"}},[_c('h1',{staticStyle:{"margin-left":"10px"}},[_vm._v("Bilder")]),_vm._l((7),function(n){return _c('img',{key:n,staticClass:"fullscreen-img",attrs:{"src":'/images/bild' + n + '.jpg'}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }